import { Component, OnInit, Input } from '@angular/core';

@Component( {
    selector: 'ridango-table-header',
    templateUrl: './table-header.component.html',
    styleUrls: [ './table-header.component.css' ]
} )
export class TableHeaderComponent implements OnInit {
    @Input() elements = [];
    constructor() { }

    ngOnInit () {
    }

}
